import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LookupEnvironmentResponse } from './LookupEnvironmentResponse';
import { CacheService } from './cache.service';

@Injectable()
export class LookupEnvironmentService {
	protected config: LookupEnvironmentResponse = new LookupEnvironmentResponse(
		'',
		'',
		'',
		null
	);
	constructor(private http: HttpClient, private cache: CacheService) {
		this.config.authWebURL = '';
		this.config.versionNumber = '';
		this.config.enhWebURL = '';
		this.fetchConfig().subscribe(
			(resp: LookupEnvironmentResponse) => {
				this.config = resp;
				console.log(resp);
				console.log(this.config);
			},
			error => {
				console.log(error);
			}
		);
	}

	// Returns the value of the passed in key name on the configuration response class
	public getConfigKeyValue(keyName: string): any {
		console.log("GET CONFIG KEY: ", this.config[keyName]);
		return this.config[keyName];
	}

	// Get the entire config response class
	public getConfig(): LookupEnvironmentResponse {
		return this.config;
	}

	fetchConfig() {
		return this.cache.get(
			'environment_config',
			this.http.get('api/environment/config')
		);
	}
	/**
	 * Gets the config object from the backend with no caching.
	 */
	FetchConfig_CacheFree(): Promise<LookupEnvironmentResponse> {
		return this.http.get<LookupEnvironmentResponse>('api/environment/config').toPromise<LookupEnvironmentResponse>();
	}

	isDisabled(featureName: string): boolean {
		let result = false;
		const found = this.config.disabledFeatures.find((x: string) => {
			if (x.toLowerCase() === featureName.toLowerCase()) {
				return true;
			}
		});
		if (found) {
			result = true;
		}
		return result;
	}
}
